import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo-detran-ba.png'
import _imports_1 from '@/assets/images/tesoura128.png'


const _hoisted_1 = { class: "bg-neutral-200" }
const _hoisted_2 = { class: "boleto-scale-wrap" }
const _hoisted_3 = { class: "text-sm w-boleto mx-auto bg-white boleto-print-scale" }
const _hoisted_4 = { class: "py-8" }
const _hoisted_5 = { class: "relative via-block" }
const _hoisted_6 = { class: "absolute right-0 -top-5" }
const _hoisted_7 = {
  class: "h-26 border-2 border-black pl-1 pb-1",
  style: {"height":"92px"}
}
const _hoisted_8 = { class: "row relative" }
const _hoisted_9 = { class: "absolute right-40 h-19 flex flex-col justify-between" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "right-0 w-32 h-19 border-l-2 border-b-2 border-black absolute text-xs" }
const _hoisted_15 = { class: "text-center font-semibold border-b-black" }
const _hoisted_16 = { class: "text-center font-bold" }
const _hoisted_17 = { class: "w-full border-lbr" }
const _hoisted_18 = {
  class: "row grid-12-columns",
  style: {"height":"35px"}
}
const _hoisted_19 = { class: "col-span-6 px-1" }
const _hoisted_20 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_21 = { class: "col-span-3 px-1 border-l-black" }
const _hoisted_22 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_23 = { class: "col-span-3 px-1 border-l-black" }
const _hoisted_24 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_25 = { class: "w-full border-lbr" }
const _hoisted_26 = {
  class: "row grid-12-columns",
  style: {"height":"35px"}
}
const _hoisted_27 = { class: "col-span-4 px-1" }
const _hoisted_28 = {
  class: "truncate text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_29 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_30 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_31 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_32 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_33 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_34 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_35 = { class: "w-full border-lbr" }
const _hoisted_36 = {
  class: "row grid-12-columns",
  style: {"height":"35px"}
}
const _hoisted_37 = { class: "col-span-4 px-1" }
const _hoisted_38 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_39 = { class: "col-span-4 px-1 border-l-black" }
const _hoisted_40 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_41 = { class: "col-span-2 ml-3 px-1 border-l-black" }
const _hoisted_42 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_43 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_44 = {
  class: "text-body-sm text-price",
  style: {"margin-top":"-5px"}
}
const _hoisted_45 = { class: "w-full border-lbr" }
const _hoisted_46 = {
  class: "row grid-12-columns",
  style: {"height":"35px"}
}
const _hoisted_47 = { class: "col-span-5 px-1" }
const _hoisted_48 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_49 = { class: "col-span-5 px-1 border-l-black" }
const _hoisted_50 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_51 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_52 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_53 = { class: "w-full border-lbr" }
const _hoisted_54 = {
  class: "row grid-12-columns",
  style: {"height":"35px"}
}
const _hoisted_55 = { class: "col-span-6 px-1" }
const _hoisted_56 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_57 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_58 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_59 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_60 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_61 = { class: "w-full border-lbr" }
const _hoisted_62 = { class: "row grid grid-cols-12" }
const _hoisted_63 = { class: "col-span-12 px-1" }
const _hoisted_64 = { class: "pl-8 pt-1 flex h-25" }
const _hoisted_65 = { class: "mt-5 ml-5 barcode-container" }
const _hoisted_66 = { class: "relative via-block" }
const _hoisted_67 = { class: "relative box-border flex flex-nowrap" }
const _hoisted_68 = { class: "absolute right-0" }
const _hoisted_69 = {
  class: "h-26 border-2 border-black pl-1 pb-1",
  style: {"height":"92px"}
}
const _hoisted_70 = { class: "row relative" }
const _hoisted_71 = { class: "absolute right-40 h-29 flex flex-col justify-between" }
const _hoisted_72 = { class: "flex" }
const _hoisted_73 = { class: "flex" }
const _hoisted_74 = { class: "flex" }
const _hoisted_75 = { class: "font-bold" }
const _hoisted_76 = { class: "right-0 w-32 h-19 border-l-2 border-b-2 border-black absolute text-xs" }
const _hoisted_77 = { class: "text-center font-semibold border-b-black" }
const _hoisted_78 = { class: "text-center font-bold" }
const _hoisted_79 = { class: "w-full border-lbr" }
const _hoisted_80 = {
  class: "row grid-12-columns",
  style: {"height":"35px"}
}
const _hoisted_81 = { class: "col-span-6 px-1" }
const _hoisted_82 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_83 = { class: "col-span-3 px-1 border-l-black" }
const _hoisted_84 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_85 = { class: "col-span-3 px-1 border-l-black" }
const _hoisted_86 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_87 = { class: "w-full border-lbr" }
const _hoisted_88 = {
  class: "row grid-12-columns",
  style: {"height":"35px"}
}
const _hoisted_89 = { class: "col-span-4 px-1" }
const _hoisted_90 = {
  class: "truncate text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_91 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_92 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_93 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_94 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_95 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_96 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_97 = { class: "col-span-1 px-1 border-l-black" }
const _hoisted_98 = {
  class: "text-body-sm text-price",
  style: {"margin-top":"-5px"}
}
const _hoisted_99 = { class: "w-full border-lbr" }
const _hoisted_100 = {
  class: "row grid-12-columns",
  style: {"height":"35px"}
}
const _hoisted_101 = { class: "col-span-5 px-1" }
const _hoisted_102 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_103 = { class: "col-span-5 px-1 border-l-black" }
const _hoisted_104 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_105 = { class: "col-span-2 ml-3 px-1 border-l-black" }
const _hoisted_106 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_107 = { class: "relative via-block" }
const _hoisted_108 = { class: "absolute right-0 -top-5" }
const _hoisted_109 = {
  class: "h-26 border-2 border-black pl-1 pb-1",
  style: {"height":"92px"}
}
const _hoisted_110 = { class: "row relative" }
const _hoisted_111 = { class: "absolute right-40 h-19 flex flex-col justify-between" }
const _hoisted_112 = { class: "flex" }
const _hoisted_113 = { class: "flex" }
const _hoisted_114 = { class: "flex" }
const _hoisted_115 = { class: "font-bold" }
const _hoisted_116 = { class: "right-0 w-32 h-19 border-l-2 border-b-2 border-black absolute text-xs" }
const _hoisted_117 = { class: "text-center font-semibold border-b-black" }
const _hoisted_118 = { class: "text-center font-bold" }
const _hoisted_119 = { class: "w-full border-lbr" }
const _hoisted_120 = {
  class: "row grid-12-columns",
  style: {"height":"35px"}
}
const _hoisted_121 = { class: "col-span-5 px-1" }
const _hoisted_122 = {
  class: "text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_123 = { class: "col-span-4 px-1 border-l-black" }
const _hoisted_124 = {
  class: "truncate text-body-sm",
  style: {"margin-top":"-5px"}
}
const _hoisted_125 = { class: "col-span-2 px-1 border-l-black" }
const _hoisted_126 = {
  class: "text-body-sm text-price",
  style: {"margin-top":"-5px"}
}
const _hoisted_127 = {
  class: "mt-5 ml-5 barcode-container",
  style: {"margin-top":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Barcode = _resolveComponent("Barcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[59] || (_cache[59] = _createElementVNode("div", { class: "relative box-border flex flex-nowrap" }, [
            _createElementVNode("small", { class: "text-xs font-semibold bg-gray-400 inset-2 border-l-2 border-t-2 border-r-2 border-black p-0.5" }, " VIA DO DETRAN "),
            _createElementVNode("div", { class: "relative text-sm font-bold ml-1 border-b-0 bg-transparent" }, [
              _createElementVNode("small", null, " Emitido pela Vsoft ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.boletoCodigo.codigoBarra1) + " " + _toDisplayString(_ctx.boletoCodigo.codigoBarra2) + " " + _toDisplayString(_ctx.boletoCodigo.codigoBarra3) + " " + _toDisplayString(_ctx.boletoCodigo.codigoBarra4), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"h-26 flex flex-col justify-between items-center absolute left-0 border-r-2 border-black px-2\"><figure class=\"w-14 h-16 mt-3\" style=\"margin-top:5px;\"><img src=\"" + _imports_0 + "\" alt=\"DETRAN-BA\"></figure></div><p class=\"w-96 left-20 text-xs font-bold ml-2 pt-1 absolute\"> GOVERNO DO ESTADO <br> SECRETARIA DE ADMINISTRAÇÃO <br> DEPARTAMENTO ESTADUAL DE TRÂNSITO <br> DH - SOLICITAÇÃO DE SERVIÇO </p><div class=\"pt-1 h-26 flex absolute left-80\"><div class=\"text-xs flex items-end\"></div></div>", 3)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[0] || (_cache[0] = _createElementVNode("small", { class: "mr-7 font-bold" }, "Emissão: ", -1)),
                    _createElementVNode("small", null, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.dataEmissaoSsDr)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[1] || (_cache[1] = _createElementVNode("small", { class: "mr-6 font-bold" }, "Abertura:", -1)),
                    _createElementVNode("small", null, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.dataAbertura)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[2] || (_cache[2] = _createElementVNode("small", { class: "mr-6 font-bold" }, "Validade:", -1)),
                    _createElementVNode("small", _hoisted_13, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.validadeServico)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-center border-b-black" }, [
                    _createElementVNode("p", { class: "font-semibold bg-gray-400" }, "RENACH")
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.boleto.nrRenach), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("small", { class: "font-semibold pl-1" }, "Pagar até", -1)),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.validadeServico)), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[6] || (_cache[6] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Serviço")
                  ], -1)),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.boleto.retorno.servico.descricao), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[7] || (_cache[7] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "CPF")
                  ], -1)),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$filters.formatCpf(_ctx.condutor.cpf)), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[8] || (_cache[8] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Carteira de Identidade")
                  ], -1)),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.condutor.nrDocumento) + " / " + _toDisplayString(_ctx.condutor.orgaoEmissorDocumento) + "/" + _toDisplayString(_ctx.condutor.ufDocumento), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[9] || (_cache[9] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Nome")
                  ], -1)),
                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.condutor.nome), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[10] || (_cache[10] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Nascimento")
                  ], -1)),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$filters.dateBRL(_ctx.condutor.dataNascimento)), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[11] || (_cache[11] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Cartegoria Pretendida")
                  ], -1)),
                  _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.boleto.retorno.categoriaAtual), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[12] || (_cache[12] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Categoria Atual")
                  ], -1)),
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.boleto.retorno.categoriaAtual), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _cache[13] || (_cache[13] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Mãe")
                  ], -1)),
                  _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.condutor.nomeMae), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _cache[14] || (_cache[14] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Pai")
                  ], -1)),
                  _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.condutor.nomePai), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _cache[15] || (_cache[15] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "A.Remunerada ")
                  ], -1)),
                  _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.condutor.atividadeRemunerada == true ? "SIM" : "NÃO"), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _cache[16] || (_cache[16] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Valor do serviço ")
                  ], -1)),
                  _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$filters.currencyBRL(_ctx.boleto.retorno.servico.valorServico)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _cache[17] || (_cache[17] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Logradouro")
                  ], -1)),
                  _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.boleto.endereco.logradouro) + " " + _toDisplayString(_ctx.boleto.endereco.numero), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _cache[18] || (_cache[18] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Complemento")
                  ], -1)),
                  _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.boleto.endereco.complemento), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _cache[19] || (_cache[19] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Telefone")
                  ], -1)),
                  _createElementVNode("p", _hoisted_52, "(" + _toDisplayString(_ctx.boleto.endereco.telefones[0].ddd) + ") " + _toDisplayString(_ctx.boleto.endereco.telefones[0].numero), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _cache[20] || (_cache[20] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Bairro / Município")
                  ], -1)),
                  _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.boleto.endereco.bairro.nomeBairro) + " / " + _toDisplayString(_ctx.boleto.endereco.bairro.municipio.descricao), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _cache[21] || (_cache[21] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "CEP ")
                  ], -1)),
                  _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$filters.formatCep(_ctx.boleto.endereco.cep)), 1)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _cache[22] || (_cache[22] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                    _createElementVNode("strong", null, "Telefone")
                  ], -1)),
                  _createElementVNode("p", _hoisted_60, "(" + _toDisplayString(_ctx.boleto.endereco.telefones[1].ddd) + ") " + _toDisplayString(_ctx.boleto.endereco.telefones[1].numero), 1)
                ])
              ])
            ]),
            _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"w-full border-lbr\"><div class=\"row grid grid-cols-12 relative h-4\"><div class=\"col-span-12 h-4 px-1\"><small class=\"headline-sm-bold\"><strong>Observações</strong></small><p class=\"pl-8 text-body-sm\"></p></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("p", _hoisted_64, " Eu, " + _toDisplayString(_ctx.condutor.nome.toUpperCase()) + " declaro a veracidade sobre todas as informações prestadas na solicitação do referido serviço e nos dados de contato tal qual endereço de residência de domicilio, intenção da emissão do serviço, além do exercício de atividade remunerada, ciente de que se falsas forem, sofrei sanções previstas na legislação aplicável, conforme determina a lei 7115/83. ", 1)
                ])
              ])
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "absolute -bottom-5 left-4 box-border" }, [
              _createElementVNode("small", { class: "text-xs font-bold p-0.5" }, " Pagável na Internet ou qualquer agência/terminal de auto-atendimento Bradesco ou Banco do Brasil ")
            ], -1)),
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "absolute -bottom-5 right-0 box-border" }, [
              _createElementVNode("small", { class: "text-xs font-semibold bg-gray-400 border-l-2 border-t-2 border-b-2 border-r-2 border-black p-0.5" }, " Autenticação Mecânica ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_Barcode, { codigo: _ctx.boletoImagem }, null, 8, ["codigo"])
          ]),
          _cache[60] || (_cache[60] = _createElementVNode("div", {
            class: "w-full my-7 border-b-2 border-dashed border-black relative",
            style: {"margin-top":"5px"}
          }, [
            _createElementVNode("img", {
              class: "absolute h-5 w-6 -top-3",
              src: _imports_1,
              alt: "DETRAN-BA"
            })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _cache[26] || (_cache[26] = _createElementVNode("small", { class: "text-xs font-semibold bg-gray-400 inset-2 border-l-2 border-t-2 border-r-2 border-black p-0.5" }, " VIA DO CLIENTE ", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "relative text-sm font-bold ml-1 border-b-0 bg-transparent" }, [
                  _createElementVNode("small", null, " Emitido pela Vsoft ")
                ], -1)),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.boletoCodigo.codigoBarra1) + " " + _toDisplayString(_ctx.boletoCodigo.codigoBarra2) + " " + _toDisplayString(_ctx.boletoCodigo.codigoBarra3) + " " + _toDisplayString(_ctx.boletoCodigo.codigoBarra4), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _cache[33] || (_cache[33] = _createStaticVNode("<div class=\"h-26 flex flex-col justify-between items-center absolute left-0 border-r-2 border-black px-2\"><figure class=\"w-14 h-16 mt-3\" style=\"margin-top:5px;\"><img src=\"" + _imports_0 + "\" alt=\"DETRAN-BA\"></figure></div><p class=\"w-96 left-20 text-xs font-bold ml-2 pt-1 absolute\"> GOVERNO DO ESTADO <br> SECRETARIA DE ADMINISTRAÇÃO <br> DEPARTAMENTO ESTADUAL DE TRÂNSITO <br> DH - SOLICITAÇÃO DE SERVIÇO </p><div class=\"pt-1 h-26 flex absolute left-80\"><div class=\"text-xs flex items-end\"></div></div>", 3)),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _cache[28] || (_cache[28] = _createElementVNode("small", { class: "mr-7 font-bold" }, "Emissão: ", -1)),
                      _createElementVNode("small", null, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.dataEmissaoSsDr)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _cache[29] || (_cache[29] = _createElementVNode("small", { class: "mr-6 font-bold" }, "Abertura:", -1)),
                      _createElementVNode("small", null, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.dataAbertura)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _cache[30] || (_cache[30] = _createElementVNode("small", { class: "mr-6 font-bold" }, "Validade:", -1)),
                      _createElementVNode("small", _hoisted_75, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.validadeServico)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "text-center border-b-black" }, [
                      _createElementVNode("p", { class: "font-semibold bg-gray-400" }, "RENACH")
                    ], -1)),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.boleto.nrRenach), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[31] || (_cache[31] = _createElementVNode("small", { class: "font-semibold pl-1" }, "Pagar até", -1)),
                      _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.validadeServico)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _cache[34] || (_cache[34] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Serviço")
                    ], -1)),
                    _createElementVNode("p", _hoisted_82, _toDisplayString(_ctx.boleto.retorno.servico.descricao), 1)
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _cache[35] || (_cache[35] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "CPF")
                    ], -1)),
                    _createElementVNode("p", _hoisted_84, _toDisplayString(_ctx.$filters.formatCpf(_ctx.condutor.cpf)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _cache[36] || (_cache[36] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Carteira de Identidade")
                    ], -1)),
                    _createElementVNode("p", _hoisted_86, _toDisplayString(_ctx.condutor.nrDocumento) + " / " + _toDisplayString(_ctx.condutor.orgaoEmissorDocumento) + "/" + _toDisplayString(_ctx.condutor.ufDocumento), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _cache[37] || (_cache[37] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Nome")
                    ], -1)),
                    _createElementVNode("p", _hoisted_90, _toDisplayString(_ctx.condutor.nome), 1)
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _cache[38] || (_cache[38] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Nascimento")
                    ], -1)),
                    _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.$filters.dateBRL(_ctx.condutor.dataNascimento)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_93, [
                    _cache[39] || (_cache[39] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Cartegoria Pretendida")
                    ], -1)),
                    _createElementVNode("p", _hoisted_94, _toDisplayString(_ctx.boleto.retorno.categoriaAtual), 1)
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    _cache[40] || (_cache[40] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Categoria Atual")
                    ], -1)),
                    _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.boleto.retorno.categoriaAtual), 1)
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _cache[41] || (_cache[41] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Valor do Serviço ")
                    ], -1)),
                    _createElementVNode("p", _hoisted_98, _toDisplayString(_ctx.$filters.currencyBRL(_ctx.boleto.retorno.servico.valorServico)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _cache[42] || (_cache[42] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Mãe")
                    ], -1)),
                    _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.condutor.nomeMae), 1)
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _cache[43] || (_cache[43] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Pai")
                    ], -1)),
                    _createElementVNode("p", _hoisted_104, _toDisplayString(_ctx.condutor.nomePai), 1)
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _cache[44] || (_cache[44] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "A.Remunerada ")
                    ], -1)),
                    _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.condutor.atividadeRemunerada == true ? "SIM" : "NÃO"), 1)
                  ])
                ])
              ]),
              _cache[45] || (_cache[45] = _createStaticVNode("<div class=\"w-full border-lbr\"><div class=\"row grid grid-cols-12 relative h-4\"><div class=\"col-span-12 h-4 px-1\"><small class=\"headline-sm-bold\"><strong>Observações</strong></small><p class=\"pl-8 text-body-sm\"></p></div></div></div><div class=\"w-full border-lbr\"><div class=\"grid grid-cols-12\"><div class=\"col-span-5 px-1\"><small class=\"\"><strong>Etapas a serem realizadas</strong></small></div><div class=\"col-span-7 px-1 border-l-black\"><small class=\"\"><strong>Procedimentos</strong></small></div></div></div><div class=\"w-full border-lbr\"><div class=\"grid grid-cols-12\"><div class=\"col-span-5 px-1\"><ul class=\"text-xs\"><li>1 - EXAME DE SANIDADE FISICA E MENTAL</li><li>2 - EXAME PSICOLOGICO</li><li>3 - EXAME DE LEGISLACAO</li><li>4 - EXAME DE DIRECAO VEICULAR E/OU 4 RODAS</li></ul></div><div class=\"col-span-7 pt-1 px-1 border-l-black text-sm\"><ul class=\"text-xs\"><li> DIRIJA-SE A UM CFC DE SUA ESCOLHA E SOLICITE 45 HORAS DE AULAS TEORICAS MARCACAO DA PROVA DE LEGISLACAO </li><li> DIRIJA-SE A UM CFC DE SUA ESCOLHA E SOLICITE 5h SIMULADOR/EMISSAO LADV/15h AULA PRATICA EMISSAO LADV/20h AULAS PRATICAS </li></ul></div></div></div>", 3))
            ]),
            _cache[46] || (_cache[46] = _createElementVNode("div", {
              class: "w-full my-7 border-b-2 border-dashed border-black relative",
              style: {"margin-top":"10px"}
            }, [
              _createElementVNode("img", {
                class: "absolute h-5 w-6 -top-3",
                src: _imports_1,
                alt: "DETRAN-BA"
              })
            ], -1))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_107, [
              _cache[56] || (_cache[56] = _createElementVNode("div", { class: "absolute -top-5 box-border" }, [
                _createElementVNode("small", { class: "text-xs font-semibold bg-gray-400 border-l-2 border-t-2 border-r-2 border-black p-0.5" }, " VIA DO BANCO"),
                _createElementVNode("small", { class: "text-xs font-bold ml-1 mb-2 absolute -top-1 w-32" }, " Emitido pela Vsoft")
              ], -1)),
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("p", null, _toDisplayString(_ctx.boletoCodigo.codigoBarra1) + " " + _toDisplayString(_ctx.boletoCodigo.codigoBarra2) + " " + _toDisplayString(_ctx.boletoCodigo.codigoBarra3) + " " + _toDisplayString(_ctx.boletoCodigo.codigoBarra4), 1)
              ]),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("div", _hoisted_110, [
                  _cache[52] || (_cache[52] = _createStaticVNode("<div class=\"h-26 flex flex-col justify-between items-center absolute left-0 border-r-2 border-black px-2\"><figure class=\"w-14 h-16 mt-3\" style=\"margin-top:5px;\"><img src=\"" + _imports_0 + "\" alt=\"DETRAN-BA\"></figure></div><p class=\"w-96 left-20 text-xs font-bold ml-2 pt-1 absolute\"> GOVERNO DO ESTADO <br> SECRETARIA DE ADMINISTRAÇÃO <br> DEPARTAMENTO ESTADUAL DE TRÂNSITO <br> DH - SOLICITAÇÃO DE SERVIÇO </p><div class=\"pt-1 h-26 flex absolute left-80\"><div class=\"text-xs flex items-end\"></div></div>", 3)),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      _cache[47] || (_cache[47] = _createElementVNode("small", { class: "mr-7 font-bold" }, "Emissão: ", -1)),
                      _createElementVNode("small", null, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.dataEmissaoSsDr)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_113, [
                      _cache[48] || (_cache[48] = _createElementVNode("small", { class: "mr-6 font-bold" }, "Abertura:", -1)),
                      _createElementVNode("small", null, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.dataAbertura)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_114, [
                      _cache[49] || (_cache[49] = _createElementVNode("small", { class: "mr-6 font-bold" }, "Validade:", -1)),
                      _createElementVNode("small", _hoisted_115, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.validadeServico)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_116, [
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "text-center border-b-black" }, [
                      _createElementVNode("p", { class: "font-semibold bg-gray-400" }, "RENACH")
                    ], -1)),
                    _createElementVNode("div", _hoisted_117, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.boleto.nrRenach), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[50] || (_cache[50] = _createElementVNode("small", { class: "font-semibold pl-1" }, "Pagar até", -1)),
                      _createElementVNode("p", _hoisted_118, _toDisplayString(_ctx.$filters.dateBRL(_ctx.boleto.retorno.servico.validadeServico)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _cache[53] || (_cache[53] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Serviço")
                    ], -1)),
                    _createElementVNode("p", _hoisted_122, _toDisplayString(_ctx.boleto.retorno.servico.descricao), 1)
                  ]),
                  _createElementVNode("div", _hoisted_123, [
                    _cache[54] || (_cache[54] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Nome")
                    ], -1)),
                    _createElementVNode("p", _hoisted_124, _toDisplayString(_ctx.condutor.nome), 1)
                  ]),
                  _createElementVNode("div", _hoisted_125, [
                    _cache[55] || (_cache[55] = _createElementVNode("small", { class: "headline-sm-bold" }, [
                      _createElementVNode("strong", null, "Valor do Serviço ")
                    ], -1)),
                    _createElementVNode("p", _hoisted_126, _toDisplayString(_ctx.$filters.currencyBRL(_ctx.boleto.retorno.servico.valorServico)), 1)
                  ])
                ])
              ]),
              _cache[57] || (_cache[57] = _createElementVNode("div", {
                class: "absolute -bottom-5 left-4 box-border",
                style: {"margin-bottom":"5px"}
              }, [
                _createElementVNode("small", { class: "text-xs font-bold p-0.5" }, " Pagável na Internet ou qualquer agência/terminal de auto-atendimento Bradesco ou Banco do Brasil ")
              ], -1)),
              _cache[58] || (_cache[58] = _createElementVNode("div", { class: "absolute -bottom-5 right-0 box-border" }, [
                _createElementVNode("small", { class: "text-xs font-semibold bg-gray-400 border-l-2 border-t-2 border-b-2 border-r-2 border-black p-0.5" }, " Autenticação Mecânica ")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createVNode(_component_Barcode, { codigo: _ctx.boletoImagem }, null, 8, ["codigo"])
            ])
          ])
        ])
      ])
    ])
  ]))
}